import { useEffect, useState } from 'react';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useGetProgrammeOverviewsQuery } from '../../redux/programmeApiV2';
import { getJourneyAndProgrammeIds } from '../../utils/JourneyUtils';

export const useProgrammeOverviews = (profileQuery) => {
  const [overviewsRequest, setOverviewsRequest] = useState(null);
  const programmeOverviewsQuery = useGetProgrammeOverviewsQuery(
    overviewsRequest ?? skipToken
  );

  useEffect(() => {
    if (!profileQuery?.isSuccess || profileQuery?.isUninitialized) {
      return;
    }

    setOverviewsRequest({
      profileId: profileQuery?.data?.userId,
      programmeAndJourneyIds: getJourneyAndProgrammeIds(profileQuery?.data),
    });
  }, [profileQuery]);

  return programmeOverviewsQuery;
};
